// extracted by mini-css-extract-plugin
export default {"medium-header":"SmallHeader_medium-header__J6gx9"};